export default {
	"Publicity.ShopAnnouncements": "Shop announcements",
	"Publicity.MarketingMallComponentClick": "Marketing Mall_Component click",
	"Publicity.MarketingMarketplace": "Marketing Marketplace"
}